"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setFieldPermissionSchema = exports.updatePermissionSchema = exports.createPermissionSchema = exports.fieldAccessLevelEnum = exports.permissionTypeEnum = void 0;
const zod_1 = require("zod");
exports.permissionTypeEnum = zod_1.z.enum(['MODULE', 'SCREEN', 'ACTION', 'FIELD', 'API']);
exports.fieldAccessLevelEnum = zod_1.z.enum(['NONE', 'READ', 'WRITE']);
exports.createPermissionSchema = zod_1.z.object({
    key: zod_1.z
        .string()
        .min(3)
        .max(150)
        .regex(/^[a-z0-9-]+:[a-z0-9-]+$/, 'Permission key must be in "module:action" format'),
    type: exports.permissionTypeEnum,
    module: zod_1.z.string().min(1).max(100),
    description: zod_1.z.string().max(500).optional(),
});
exports.updatePermissionSchema = exports.createPermissionSchema
    .omit({ key: true })
    .partial();
exports.setFieldPermissionSchema = zod_1.z.object({
    roleId: zod_1.z.string().uuid(),
    entityType: zod_1.z.string().min(1).max(100),
    fieldName: zod_1.z.string().min(1).max(100),
    accessLevel: exports.fieldAccessLevelEnum,
});
//# sourceMappingURL=permission.schema.js.map